import {params_with_csrf_token} from 'utils/form_utils'
import {link_button, element_with_class, element_with_content} from 'utils/material_elements'
import {User} from 'utils/user'
import {FlashMessage} from 'components/flash'

export class NotificationsSignupForm

  constructor: ->
    @showReleventMessage()
    @form = document.querySelector('.option.shown form.notification-onboard')
    @prepareForm() if @form

  prepareForm: ->
    @box = document.querySelector('.notification-signup-box')
    @security = document.querySelector('h1 span:first-child').innerText
    @form.addEventListener 'submit', (e) => @formSubmitted(e)

  showReleventMessage: ->
    if User.isLoggedIn()
      document.querySelector('.sign-up .option.shown').classList.remove('shown')
      if User.hasNotification(document.querySelector('h1').dataset.id)
        document.querySelector('.sign-up .option.in-watch-list').classList.add('shown')
      else
        document.querySelector('.sign-up .option.not-in-watch-list').classList.add('shown')

  formSubmitted: (e) ->
    e.preventDefault()

    @setError("")
    params = params_with_csrf_token()
    input = document.querySelector('.option.shown form.notification-onboard input#email')
    params.append(input.name, input.value) if input
    fetch(@form.getAttribute('action'), method: 'POST', body: params, headers: {'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'}).then (response) => @handleResponse(response)

  handleResponse: (response) ->
    response.json().then (json) =>
      if User.isLoggedIn()
        @addNotificationResponse(json)
      else
        @signupResponse(json)

  addNotificationResponse: (json) ->
    if json.success
      FlashMessage.success "#{@security} notification added successfully"
      @addNotificationSuccess()
    else
      @addNotificationError(json)

  addNotificationSuccess: ->
    document.querySelector('.sign-up .option.shown').classList.remove('shown')
    document.querySelector('.sign-up .option.in-watch-list').classList.add('shown')

  addNotificationError: (json) ->
    error = json.message or json.error
    @setError(error)

  signupResponse: (json) ->    
    if json.status == 0
      @redirectToNotifications()
    else if json.status == 1
      @redirectToCreateAccount()
    else
      @showLoginMessage()

  setBoxContent: (element) ->
    @box.removeChild(@box.firstChild) while @box.firstChild
    @box.append element

  redirectToNotifications: ->
    quantity = document.querySelector('#holding').value
    email = encodeURIComponent @emailInput()
    shareId = @form.dataset.shareId
    document.location = "/dividends/notifications?email=#{email}&share=#{shareId}&quantity=#{quantity}"

  redirectToCreateAccount: ->
    document.location = "/users/create_free_account?email=#{encodeURIComponent @emailInput()}"

  showLoginMessage: ->
    @setError("This email address is already registered. Please <a href=\"/login\">sign in</a>")

  setError: (message) ->
    error = document.querySelector('.notification-signup-box .option.shown .error-message')
    error.innerHTML = message

  emailInput: ->
    document.querySelector('#email').value